import React from 'react'
// NAVIGATION
import { Link } from 'react-router-dom'
// IMAGE
import imageLogin from '../../../images/connecter.png'
import logo from '../../../images/logo3.png'

const HeaderHomeEquipe = ({ surname, name }) => {
    return (
        <div>
            <div className='row py-3 shadow bg-body' style={{ height:'4rem' }}>

                {/* LOGO APPLY SOLUTION */}
                <div className='col-2 text-center'>
                    <img src={logo} alt='logo' style={{ height:'2.2rem', width:'2.2rem' }} />
                </div>

                {/* SURNAME NAME */}
                <div className='col text-end align-self-center'>{surname} {name}</div>

                {/* LOGIN + NAVIGATION */}
                <div className='col-2 text-end align-self-center' style={{cursor:'pointer'}}>
                    <Link to='/authUser' /*state={{ keyUid:user.uid }}*/ style={{ color:'black' }}>
                        <img src={imageLogin} alt='profil' style={{ height:'2.2rem', width:'2.2rem' }} />
                    </Link>
                </div>

            </div>

        </div>
    )
}

export default HeaderHomeEquipe